<button id="tutoButtonId" (click)="launchTuto()" [hidden]="!showTuto" class="tutoButton" >
  <i class="fas fa-book-open"></i>
</button>
